import React, { useState, useEffect, useContext } from "react";
import "./CheckoutPage.css";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import StickyComponent from "./Sticky_component";
import { Dialog, DialogActions, DialogContent, DialogContentText, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { paymentContext } from "./context";

const billingFields = [
  {
    label: "First name *",
    name: "first_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Last name *",
    name: "last_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Company name (optional)",
    name: "company_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "GSTIN (optional)",
    name: "gstin",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Salesman's name (optional)",
    name: "salesman_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Store name (optional)",
    name: "store_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Country / Region *",
    name: "country_region",
    type: "text",
    placeholder: "",
    disable: true,
    required: true,
    value: "India",
  },
  {
    label: "Landmark *",
    name: "landmark",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Street address *",
    name: "street_address",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Apartment, suite, etc. (optional)",
    name: "apartment",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Town / City *",
    name: "city",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "State *",
    name: "state",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Pincode *",
    name: "pincode",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Phone *",
    name: "phone",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Email *",
    name: "email",
    type: "email",
    placeholder: "",
    disable: false,
    required: true,
  },
];

const shippingFields = [
  {
    label: "First name *",
    name: "first_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Last name *",
    name: "last_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Company name (optional)",
    name: "company_name",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Country / Region *",
    name: "country_region",
    type: "text",
    placeholder: "",
    disable: true,
    required: true,
    value: "India",
  },
  {
    label: "Street address *",
    name: "street_address",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Apartment, suite, etc. (optional)",
    name: "apartment",
    type: "text",
    placeholder: "",
    disable: false,
    required: false,
  },
  {
    label: "Town / City *",
    name: "city",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "State *",
    name: "state",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  },
  {
    label: "Pincode *",
    name: "pincode",
    type: "text",
    placeholder: "",
    disable: false,
    required: true,
  }
];

function CheckoutPage() {

  const [formValues, setFormValues] = useState(
    billingFields.reduce((acc, field) => {
      acc[field.name] = field.value || "";
      return acc;
    }, {})
  );

  const [shippingformValues, setShippingFormValues] = useState(
    shippingFields.reduce((acc, field) => {
      acc[field.name] = field.value || "";
      return acc;
    }, {})
  );

  const commonFields = billingFields
    .filter((billingField) =>
      shippingFields.some(
        (shippingField) => shippingField.name === billingField.name
      )
    )
    .map((field) => field.name);
  const [paymentHtml, setPaymentHtml] = useState('');
  const [showShippingForm, setShowShippingForm] = useState(false);
  const [cart, setCart] = useState([]);
  const [shippingCost, setShippingCost] = useState(197); // Flat rate shipping
  const [subtotal, setSubtotal] = useState(0);
  const [token, setToken] = useState('');
  const [orderNotes, setOrderNotes] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [messageContent, setMessageContent] = useState('');
  const [success, setSuccess] = useState(true);
  const [open, setOpen] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [coupon, setCoupon] = useState(null);
  const navigate = useNavigate();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {setPaymentInfo, setIsPaymentOnProgress} = useContext(paymentContext);
  useEffect(() => {
    try {
      const cartData = JSON.parse(localStorage.getItem("cart")) || [];
      setCart(cartData);
      if (cartData.length !== 0) {
        const total = cartData?.reduce(
          (acc, item) => acc + item.price * item.quantity,
          0
        );
        setSubtotal(total);
      } else {
        setShowMessage(true);
        setMessageContent('Cart is empty');
        setSuccess(false);
      }
      const savedBillingAddress = localStorage.getItem("billing_address");
      if (savedBillingAddress) {
        setFormValues(JSON.parse(savedBillingAddress));
      }

      const savedShippingAddress = localStorage.getItem("shipping_address");
      if (savedShippingAddress) {
        setShippingFormValues(JSON.parse(savedShippingAddress));
      }

      const token = localStorage.getItem('token');
      if (token) {
        setToken(JSON.parse(token));
      } else {
        navigate('/register-login');
      }

      const coupon = localStorage.getItem('coupon');
      if (coupon) {
        setCoupon(JSON.parse(coupon));
      }

    } catch (error) {
      console.error('Error parsing initial data:', error);
    }

  }, []);


  useEffect(() => {
    if (open && paymentHtml) {
      // Use setTimeout to ensure the DOM is fully rendered
      const timer = setTimeout(() => {
        const formElement = document.getElementById('payment_post');
        if (formElement) {
          formElement.submit();
        }
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [open, paymentHtml]);

  const shippinghandleChange = (e) => {
    const { name, value } = e.target;
    setShippingFormValues((prev) => ({ ...prev, [name]: value }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };
  const isFormValid = () => {
    const areBillingFieldsValid = billingFields.every(
      (field) =>
        !field.required || (formValues[field.name] && formValues[field.name].trim() !== "")
    );
    const areShippingFieldsValid = !showShippingForm || shippingFields.every(
      (field) =>
        !field.required || (shippingformValues[field.name] && shippingformValues[field.name].trim() !== "")
    );

    return areBillingFieldsValid && areShippingFieldsValid;
  };
  const total = (coupon) ? (subtotal > 5000) ? subtotal - coupon?.discount_applied : (subtotal + shippingCost - coupon?.discount_applied) : (subtotal > 5000) ? subtotal : (subtotal + shippingCost);
  async function handlePlaceOrder() {

    try {
      if (isFormValid() && token) {
        const pincode = (showShippingForm) ? shippingformValues.pincode : formValues.pincode;
        const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/pincode-check', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "pincode": pincode
          })
        })

        const data = await response.json();
        //console.log("pincode check", data)
        if (data.statusCode !== 200) {
          return;
        }

        const responseAPIGateway = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/payment-gateway', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "body": {
              "amount": total,
              "productinfo": cart.map(item => item?.model).join(", "),
              "firstname": `${formValues.first_name} ${formValues.last_name}`,
              "email": formValues.email,
              "phone": token,
              "surl": "https://www.khoslaonline.com/success",
              "furl": "https://www.khoslaonline.com/failure"
            }
          })
        });
        const dataGatway = await responseAPIGateway.json();
        const cleanedBody = dataGatway.body.replace(/NaN/g, "null");
        const parsedData = JSON.parse(cleanedBody);
        console.log("payment gateway response", parsedData);
        console.log("payment gateway response", parsedData?.checkout_url);
        if (parsedData?.checkout_url) {
          setPaymentInfo({
            "token": token,
            "billing_address": formValues,
            "shipping_address": (showShippingForm) ? shippingformValues : commonFields.reduce((acc, field) => {
              acc[field] = formValues[field];
              return acc;
            }, {}),
            "cart": cart,
            "order_notes": orderNotes,
            "order_status": "Order Placed",
            "coupon": coupon
          })
          setIsPaymentOnProgress(true);
          
          setPaymentHtml(parsedData?.checkout_url);
          handleOpen();
        }

       


        // this will be needed for production 


        // const responseAPI = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/check-out', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify({
        //     "token": token,
        //     "billing_address": formValues,
        //     "shipping_address": (showShippingForm) ? shippingformValues : commonFields.reduce((acc, field) => {
        //       acc[field] = formValues[field];
        //       return acc;
        //     }, {}),
        //     "cart": cart,
        //     "order_notes": orderNotes,
        //     "order_status": "Order Placed",
        //     "coupon": coupon
        //   })
        // })

        // const data2 = await responseAPI.json();

        // //console.log("place order response", data2);
        // if (data2.statusCode === 200) {
        //   setShowMessage(true);
        //   setMessageContent("Order Placed Successfully");
        //   setSuccess(true);
        //   localStorage.removeItem('cart');
        //   localStorage.removeItem('coupon');

        // } else {
        //   setShowMessage(true);
        //   setMessageContent("Failed to place order");
        //   setSuccess(false);
        // }

      }



    } catch (error) {
      console.log("error", error);
    }


    // this is for testing not for production
    // if (isFormValid() && token) {
    //   console.log("full json",{
    //     cart: cart,
    //     billing_address: formValues,
    //     shipping_address: (showShippingForm) ? shippingformValues : commonFields.reduce((acc, field) => {
    //       acc[field] = formValues[field];
    //       return acc;
    //     }, {}),
    //     token: token,
    //     order_notes: orderNotes
    //   });
    // console.log("cart", cart);
    // console.log("billing address", formValues);
    // console.log("shipping address", (showShippingForm) ? shippingformValues : commonFields.reduce((acc, field) => {
    //   acc[field] = formValues[field];
    //   return acc;
    // }, {}));
    // console.log("token", token);
    // console.log("order notes", orderNotes);
    // setShowMessage(true);
    // setMessageContent('Order Placed Successfully')
    // setSuccess(true);

    // localStorage.setItem("cart", JSON.stringify([]));

    // }
  }
  function handleDialogueClick() {
    window.location.href = redirectUrl;
  }

  function handleOrderNotes(e) {
    setOrderNotes(e.target.value);
  }
  return (
    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>

      {
        showMessage && <div className={`checkout-notification ${success ? 'success' : 'fail'}`}>
          <p>{messageContent}</p>
        </div>
      }
      <div className="checkout-page-container" disabled={(!token)}>
        <h1 className="checkout-page-title">Checkout Page</h1>
        <div className="checkout-container">
          <div className="checkout-address">
            <div className="checkout-billing-address-container">
              <h4>Billing Address</h4>
              <div className="checkout-billing-address-billing-form">
                <form >
                  {billingFields.map((field, index) => (
                    <div className="checkout-billing-address-form-group" key={index}>
                      <label htmlFor={field.name}>{field.label}</label>
                      <input
                        id={field.name}
                        name={field.name}
                        type={field.type}
                        placeholder={field.placeholder}
                        disabled={field.disable}
                        required={field.required}
                        value={formValues[field.name]}
                        onChange={handleChange}
                      />
                    </div>
                  ))}
                </form>
              </div>
            </div>

            <div className="shipping-details-container">
              <h2>Shipping Details</h2>
              <div>
                <label>
                  <input
                    type="checkbox"
                    checked={showShippingForm}
                    onChange={() => setShowShippingForm(!showShippingForm)}
                  />
                  Ship to a different address?
                </label>
              </div>
              {showShippingForm && (
                <div className="checkout-shipping-address-billing-form">
                  <form>
                    {shippingFields.map((field, index) => (
                      <div className="checkout-shipping-address-form-group" key={index}>
                        <label htmlFor={field.name}>{field.label}</label>
                        <input
                          id={field.name}
                          name={field.name}
                          type={field.type}
                          placeholder={field.placeholder}
                          disabled={field.disable}
                          required={field.required}
                          value={shippingformValues[field.name]}
                          onChange={shippinghandleChange}
                        />
                      </div>
                    ))}
                  </form>
                </div>
              )}
            </div>

            <div className="checkout-order-notes">
              <label>Order Notes{`(optional)`}</label>
              <textarea placeholder="Notes about your order, e.g. special notes for delivery." onChange={handleOrderNotes} />
            </div>
          </div>

          <div className="checkout-order-summary">
            <h2 className="checkout-title">Your Order</h2>
            <table className="checkout-order-table">
              <thead>
                <tr>
                  <th className="checkout-order-header">Product</th>
                  <th className="checkout-order-header">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {cart.map((item, index) => (
                  <tr key={index} className="checkout-order-row">
                    <td className="checkout-order-product">
                      {item.name} × {item.quantity}
                    </td>
                    <td className="checkout-order-price">
                      ₹{(item.price * item.quantity).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* <div className="checkout-order-totals">
              <div className="checkout-order-total-row">
                <span>Subtotal</span>
                <span>₹{subtotal.toLocaleString()}</span>
              </div>
              <div className="checkout-order-total-row">
                <span>Shipping</span>
                <div>
                  <input
                    type="radio"
                    id="freeShipping"
                    name="radio"
                    onChange={() => setShippingCost(0)}
                    checked={shippingCost === 0}
                  />
                  <label htmlFor="freeShipping">Free shipping</label>
                  <br />
                  <input
                    type="radio"
                    id="flatRate"
                    name="radio"
                    checked={shippingCost === 197}
                    onChange={() => setShippingCost(197)}
                  />
                  <label htmlFor="flatRate">Flat rate: ₹197</label>
                </div>
              </div>
              <div className="checkout-order-total-row">
                <span>Exchange Product :</span>
                <span>₹0.00</span>
              </div>
              <div className="checkout-order-total checkout-order-total-row">
                <span>Total</span>
                <span>₹{total.toLocaleString()}</span>
              </div>
            </div> */}

            <div className="checkout-order-totals">
              <div className="checkout-order-total-row">
                <span>Subtotal</span>
                <span>₹{subtotal.toLocaleString()}</span>
              </div>
              <div className="checkout-order-total-row">
                <span>Shipping</span>
                <div>
                  {subtotal > 5000 ? (
                    <div>
                      <p>Free shipping</p>
                    </div>
                  ) : (
                    <div>
                      {/* <input
                        type="radio"
                        id="freeShipping"
                        name="radio"
                        onChange={() => setShippingCost(0)}
                        checked={shippingCost === 0}
                      />
                      <label htmlFor="freeShipping">Free shipping</label>
                      <br />
                      <input
                        type="radio"
                        id="flatRate"
                        name="radio"
                        checked={shippingCost === 197}
                        onChange={() => setShippingCost(197)}
                      />
                      <label htmlFor="flatRate">Flat rate: ₹197</label> */}
                      <p>Flat rate: ₹197</p>
                    </div>
                  )}
                </div>
              </div>
              {coupon &&
                <div className="checkout-order-total-row">
                  <span>{`Coupon(${coupon?.coupon_name}) :`}</span>
                  <span>{`-₹${coupon?.discount_applied}`}</span>
                </div>
              }
              <div className="checkout-order-total-row">
                <span>Exchange Product :</span>
                <span>₹0.00</span>
              </div>
              <div className="checkout-order-total checkout-order-total-row">
                <span>Total</span>
                <span>₹{total.toLocaleString()}</span>
              </div>
            </div>


            <div className="checkout-payment-info">
              <p>Pay securely by Credit or Debit card or net banking through PayU.</p>
              <p>
                Your personal data will be used to process your order, support your
                experience throughout this website, and for other purposes described
                in our privacy policy.
              </p>
            </div>

            <p>You will be redirected to a third-party website for payment* </p>
            <button className="checkout-place-order-btn" disabled={(!isFormValid() || !token)} onClick={handlePlaceOrder}>Place order</button>
          </div>
        </div>
      </div>

      {
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
          'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
          '_blank'
        )} />
      }
      <About_p />
      <Footer />

      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown
        disableBackdropClick
      >
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: paymentHtml }} />
          {/* Add a loading indicator */}
          <p>Redirecting to payment gateway...</p>
        </DialogContent>
      </Dialog>

      <StickyComponent />
    </>
  );
}

export default CheckoutPage;

